import { FormError } from 'shared/components/FormControl';

import Button from 'design-system/components/Button';
import Input from 'design-system/components/Input';
import Spacer from 'design-system/components/Spacer';
import { HStack } from 'design-system/components/Stack';
import { Label } from 'design-system/components/Text';
import { useFormSecurely } from 'lib/security/reactHookForm';

interface FormCreateCaseQueueProps {
  submit: (formData: CreateCaseQueueFormData) => void;
  handleCancel: () => void;
}
const FormCreateCaseQueue = ({ handleCancel, submit }: FormCreateCaseQueueProps) => {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors, isValid },
  } = useFormSecurely<CreateCaseQueueFormData>({
    mode: 'onChange',
  });
  return (
    <form onSubmit={handleSubmit(submit)}>
      <Label size='md' htmlFor='form-create-case-queue__name' weight='bold'>
        Queue name
      </Label>
      <Spacer height={1} />
      <Input
        {...register('name', {
          required: 'Please give your queue a name',
          minLength: {
            value: 2,
            message: 'Queue names must be at least 2 letters long',
          },
        })}
        id='form-create-case-queue__name'
        placeholder='Name'
        type='text'
      />
      {errors.name && <FormError>{errors.name.message}</FormError>}
      <Spacer height={3} />

      <HStack equal={true}>
        <Button
          variant='basic'
          id='form-create-case-queue__cancel'
          data-test='form-create-case-queue__cancel'
          disabled={isSubmitting}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          type='submit'
          data-test='form-create-case-queue__submit'
          disabled={isSubmitting || !isValid}
          isPending={isSubmitting}
        >
          Create
        </Button>
      </HStack>
    </form>
  );
};

export interface CreateCaseQueueFormData {
  name: string;
}

export default FormCreateCaseQueue;
